module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Calendar"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/rent-a-space"
    }
  }, [_vm._v("Venue Event Space")]), _vm._v(" -\n      "), _c('a', {
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to book Progressbar Event Space!"
    }
  }, [_vm._v("Book Event Space")])], 1), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://calendar.google.com/calendar/embed?src=progressbar.sk_3835313939343335353737%40resource.calendar.google.com&ctz=Europe%2FPrague&showTitle=0&wkst=2&showPrint=0&showCalendars=0",
      "loading": "lazy",
      "width": "800",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "rent-meeting-room-coworking-bratislava"
    }
  }, [_vm._v("\n          Meeting Room")]), _vm._v(" -\n        "), _c('a', {
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to book Progressbar Meeting Room!"
    }
  }, [_vm._v("Book meeting room")])], 1), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://calendar.google.com/calendar/embed?src=progressbar.sk_3238323439303131393037%40resource.calendar.google.com&ctz=Europe%2FPrague&showTitle=0&wkst=2&showPrint=0&showCalendars=0&mode=WEEK",
      "loading": "lazy",
      "width": "800",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('h1', [_vm._v("Boxik Room")]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://calendar.google.com/calendar/embed?src=progressbar.sk_32303436333937303934%40resource.calendar.google.com&ctz=Europe%2FPrague&showTitle=0&wkst=2&showPrint=0&showCalendars=0&mode=WEEK",
      "loading": "lazy",
      "width": "800",
      "height": "600",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ca10e3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar.vue
// module id = 250
// module chunks = 11